export class Auditoria {
    id: number;
    cambioanterior: any;
    cambionuevo: any;
    tabla: string;
    type: string;
    campo: any;
    usuario: any;
    fechaBaja: Date;
    fecha: Date;
}